import { Icon } from '@chakra-ui/react';

export default function EllipsisIcon(props) {
  return (
    <Icon
      width='28px'
      height='28px'
      viewBox='0 0 28 28'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M7.22786 16.1419C6.27083 16.1419 5.49609 15.3763 5.49609 14.4193C5.49609 13.4622 6.27083 12.6875 7.22786 12.6875C8.1849 12.6875 8.95052 13.4622 8.95052 14.4193C8.95052 15.3763 8.1849 16.1419 7.22786 16.1419ZM14 16.1419C13.043 16.1419 12.2682 15.3763 12.2682 14.4193C12.2682 13.4622 13.043 12.6875 14 12.6875C14.957 12.6875 15.7227 13.4622 15.7227 14.4193C15.7227 15.3763 14.957 16.1419 14 16.1419ZM20.7721 16.1419C19.8151 16.1419 19.0404 15.3763 19.0404 14.4193C19.0404 13.4622 19.8151 12.6875 20.7721 12.6875C21.7292 12.6875 22.5039 13.4622 22.5039 14.4193C22.5039 15.3763 21.7292 16.1419 20.7721 16.1419Z' />
    </Icon>
  );
}
